import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Copy, CheckCircle2, Building2 } from "lucide-react";
import { api } from "../lib/api";
import { toast } from "sonner";

export default function BankTransfer() {
  const [params] = useSearchParams();
  const orderId = params.get("order_id");
  const [order, setOrder] = useState(null);
  const [iban, setIban] = useState("");
  const [holder, setHolder] = useState("");

  useEffect(() => {
    api.get("/orders").then(r => {
      const o = r.data.find(x => x.id === orderId);
      if (o) setOrder(o);
    }).catch(() => {});
    api.get("/bank-details").then(r => { setIban(r.data.iban); setHolder(r.data.holder); }).catch(() => {});
  }, [orderId]);

  const copy = (txt) => { navigator.clipboard.writeText(txt); toast.success("Copiat"); };

  return (
    <main className="pt-32 pb-20 min-h-screen" data-testid="bank-transfer-page">
      <div className="max-w-2xl mx-auto px-6">
        <div className="text-center mb-10">
          <CheckCircle2 size={48} strokeWidth={1} className="text-[#D4AF37] mx-auto mb-4" />
          <p className="label-luxe text-[#D4AF37] mb-3">Comandă Înregistrată</p>
          <h1 className="h-display text-4xl sm:text-5xl text-[#F8F4E6] mb-4">Plata în Așteptare</h1>
          <p className="text-[#A39E8A]">Te rugăm să efectuezi un transfer bancar cu detaliile de mai jos. Comanda va fi expediată după confirmarea plății.</p>
        </div>

        <div className="bg-[#0a0a0a] border border-[#D4AF37]/20 p-8 space-y-6">
          <div className="flex items-center gap-3 pb-5 border-b border-[#D4AF37]/15">
            <Building2 size={22} className="text-[#D4AF37]" />
            <p className="font-serif text-2xl text-[#F8F4E6]">Date pentru Transfer</p>
          </div>

          <Field label="IBAN" value={iban || "Se încarcă..."} onCopy={() => copy(iban)} testId="iban" />
          <Field label="Beneficiar" value={holder || "Se încarcă..."} onCopy={() => copy(holder)} testId="holder" />
          {order && <Field label="Sumă" value={`${order.amount} RON`} onCopy={() => copy(`${order.amount}`)} testId="amount" />}
          <Field label="Detalii plată (OBLIGATORIU)" value={orderId} onCopy={() => copy(orderId)} highlight testId="order-id" />
        </div>

        <div className="mt-8 p-6 border border-[#D4AF37]/15 text-sm text-[#A39E8A] leading-relaxed">
          <p className="font-medium text-[#F8F4E6] mb-2">⚠️ Important</p>
          <ul className="space-y-1.5 list-disc list-inside">
            <li>Folosește <strong className="text-[#D4AF37]">{orderId}</strong> ca detaliu plată — așa identificăm comanda</li>
            <li>Vei primi email cu aceste detalii</li>
            <li>Procesăm comanda în max 24h după confirmarea plății</li>
            <li>Pentru orice întrebare: <a href="/contact" className="text-[#D4AF37]">contactează-ne</a></li>
          </ul>
        </div>

        <div className="text-center mt-10 flex gap-4 justify-center flex-wrap">
          <Link to="/account" className="btn-gold" data-testid="view-orders">Vezi Comenzile</Link>
          <Link to="/shop" className="btn-ghost">Continuă Cumpărăturile</Link>
        </div>
      </div>
    </main>
  );
}

function Field({ label, value, onCopy, highlight, testId }) {
  return (
    <div className="flex justify-between items-center gap-4" data-testid={`bt-field-${testId}`}>
      <div className="flex-1 min-w-0">
        <p className="label-luxe mb-1">{label}</p>
        <p className={`font-mono text-lg break-all ${highlight ? "text-[#D4AF37]" : "text-[#F8F4E6]"}`}>{value}</p>
      </div>
      <button onClick={onCopy} className="text-[#A39E8A] hover:text-[#D4AF37] transition flex-shrink-0" aria-label="Copy" data-testid={`copy-${testId}`}>
        <Copy size={16} />
      </button>
    </div>
  );
}
